import classNames from "classnames"
import styles from "./BolusEventModal.module.scss"
import type { BolusEventProps } from "./BolusEventProps"
import { usePolyglot } from "src/contexts"
import { useDisplayGlucoseString } from "src/hooks"

const prefix = "components.event_modal.bolus."

export function GlucoseValue(props: BolusEventProps) {
  const { userEvent } = props
  const polyglot = usePolyglot()
  const getDisplayGlucoseString = useDisplayGlucoseString()

  if (!userEvent.bolus?.glucose_mg_dl) {
    return null
  }

  return (
    <>
      <div className={styles.row}>
        <span
          className={classNames(
            styles.textMediumBold,
            styles.keyText,
          )}
        >
          {polyglot.t(`${prefix}glucose`)}
        </span>
        <span className={styles.textMediumBold}>
          {getDisplayGlucoseString(userEvent.bolus.glucose_mg_dl)}
        </span>
      </div>
      <div className={styles.separator} />
    </>
  )
}
